import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'em-display-property',
  styleUrls: ['./display-property.component.less'],
  templateUrl: './display-property.component.html',
  standalone: false,
})
export class DisplayPropertyComponent {
  @Input() public emptyText = 'No data';
  @Input() public templateIsEmpty = false;

  public isTemplate = false;
  public stringValue = '';
  public inputTemplate?: TemplateRef<unknown>;

  @Input() public set value(value: TemplateRef<unknown> | boolean | number | string | undefined) {
    if (value instanceof TemplateRef) {
      this.isTemplate = true;
      this.inputTemplate = value;

      return;
    }

    // Reset the template state so a primitive value received after a template
    // renders the string branch instead of a stale template.
    this.isTemplate = false;
    this.inputTemplate = undefined;

    if (typeof value === 'boolean') {
      this.stringValue = value ? 'Yes' : 'No';
    } else {
      // Guard against nullish bindings (e.g. an optional `comment`); the
      // template renders the "No data" fallback when stringValue is empty.
      this.stringValue = value?.toString() ?? '';
    }
  }
}
